/* eslint-disable react/no-danger */
import { h, Fragment } from 'preact';
import { useState, useRef } from 'preact/hooks';
import CloseIcon from '../utils/icons/close.svg';
import useLockBodyScroll from '../utils/useLockBodyScroll';

const AKOAFlyout = ({
  element,
  isOpenAkoa,
  setIsOpenAkoa,
  formSubmited,
  setFormSubmited,
}) => {
  const modalClass = isOpenAkoa ? 'modal panel-active' : 'modal modal--closed';
  const [agreementAccepted, setAgreementAccepted] = useState(false);
  const [fullName, setFullName] = useState('');
  const [formInvalid, setFormInvalid] = useState(false);

  const checkedStatus = useRef(false);
  const inputFullName = useRef('');

  const AkoaData = JSON.parse(
    element.querySelector('[data-akoa-data]').textContent,
  );

  const handleCloseClick = (e) => {
    e.preventDefault();
    setIsOpenAkoa(false);
  };

  useLockBodyScroll();

  const submitVerify = (e) => {
    e.preventDefault();
    if (!agreementAccepted) {
      setFormInvalid('Agreement is not accepted!');
      return false;
    }
    if (fullName === '') {
      setFormInvalid("Full name can't be empty!");
      return false;
    }
    sessionStorage.setItem('accepted_akoa', true);
    const updateAttributesEvent = new CustomEvent('cart:updateAttributes', {
      detail: {
        payload: [
          {
            key: 'accepted_akoa',
            value: 'true',
          },
          {
            key: 'accepted_akoa_name',
            value: fullName,
          },
        ],
      },
    });

    document.dispatchEvent(updateAttributesEvent);
    setFormSubmited(true);
    setIsOpenAkoa(false);
    return false;
  };

  return (
    <>
      {isOpenAkoa && (
        <div
          className="bg-bg-3 opacity-70 w-screen  h-screen z-20 inset-1/2 translate-y-[-50%] translate-x-[-50%] fixed"
          onClick={handleCloseClick}
        />
      )}
      <div
        className={`${modalClass} fixed laptop:!max-h-[calc(100vh-170px)] !left-[50%] max-w-width w-[585px] laptop:top-auto bg-white z-30 transition-transform ease-ease delay-300 flex-col flex
            pl-[43px] pr-[32px] py-[37px]
            !-translate-x-1/2 ${
              isOpenAkoa
                ? 'laptop:!top-[50%] laptop:!-translate-y-1/2 !top-[30px] !max-w-[calc(100vw-40px)] !max-h-[calc(100vh-150px)]'
                : 'laptop:translate-y-full'
            } laptop:rounded-t-sm`}
      >
        <div className="flex justify-between pl-[5px] py-3.5 pr-5 tablet:py-0 tablet:px-0">
          <h5 className="heading-5">{AkoaData.akoa_title}</h5>
          <button onClick={handleCloseClick} aria-label="Close the flyout">
            <CloseIcon />
          </button>
        </div>
        <div className="custom-scrollbar flex flex-col justify-between gap-12 pb-3.5 pl-[5px] pr-[15px] tablet:py-0 tablet:px-[30px] tablet:mt-11 overflow-y-auto ">
          <p className="font-m-14 laptop:font-m-18 text-black">
            {AkoaData.akoa_heading}
          </p>
          <div
            className={'mb-[25px] rte font-r-10 laptop:font-r-12 text-black'}
            dangerouslySetInnerHTML={{ __html: AkoaData.akoa_content }}
          />
          {!formSubmited && (
            <form
              onSubmit={(e) => submitVerify(e)}
              className={`${!formInvalid ? '' : 'invalid'}`}
              id="akoa-form"
            >
              <div
                class={`form-error ${
                  !formInvalid ? '' : 'hidden'
                } font-r-10 text-accent-1 mb-2`}
              >
                {formInvalid}
              </div>
              <div class=" relative tablet:max-w-md border-primary-1 focus:border-primary-1 mb-[10px] laptop:mb-[20px]">
                <input
                  id="akoa_name"
                  type="text"
                  name="agreementfullname"
                  class=" peer input text-primary-1 border-primary-1 focus:border-primary-1 capitalize !bg-transparent focus:ring-0 !bg-none"
                  value={fullName}
                  autocorrect="off"
                  autocapitalize="off"
                  placeholder=" "
                  autocomplete="text"
                  onChange={() => setFullName(inputFullName.current.value)}
                  ref={inputFullName}
                />
                <label class="input-label text-primary-1" for="akoa_name">
                  Full Name
                </label>
                <button
                  type="submit"
                  class="input-button text-primary-1"
                  aria-label="Full Name"
                >
                  <svg
                    class=""
                    width="24"
                    height="25"
                    viewBox="0 0 24 25"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M4.45459 12.5659L18.6364 12.5659"
                      stroke="currentColor"
                      stroke-linecap="round"
                    />
                    <path
                      d="M14.2729 7.00854L19.7275 12.566L14.2729 18.1235"
                      stroke="currentColor"
                      stroke-linecap="round"
                    />
                  </svg>
                </button>
              </div>
              <p className={`font-m-14 text-primary-1 mb-[10px]`}>Agreement</p>
              <input
                id="agreement_accept"
                type="checkbox"
                onChange={() =>
                  setAgreementAccepted(checkedStatus.current.checked)
                }
                ref={checkedStatus}
                class="hidden peer"
              />
              <label
                for="agreement_accept"
                class="styled-checkbox peer-checked:after:block cursor-pointer font-[325]"
              >
                I have read and accept the above AKOA Agreement
              </label>
              <button
                type="submit"
                className={'btn-primary-fill text-white my-[20px]'}
              >
                Accept
              </button>
            </form>
          )}
        </div>
      </div>
    </>
  );
};

export default AKOAFlyout;
